import { FormHandles } from "@unform/core";

import { InputTypes } from "../UserData.screen";

import { reduceFormErrors } from "./signUp.reduceFormErrors";

export type StatusReasonProps =
  | "bad_gateway_error"
  | "birthdate_invalid"
  | "birthdate_minor"
  | "cell_phone_number_already_exists_error"
  | "document_already_exists"
  | "cpf_irregular"
  | "password_invalid"
  | "step_divergent_error"
  | "system_unavailable"
  | "token_expired"
  | "invalid_token_error"
  | "token_not_resend"
  | "token_successfully_resubmitted"
  | "user_name_already_exists_error"
  | "user_name_invalid"
  | "validation_error"
  | "status_invalid";

export const errorMessages: {
  [keyof in StatusReasonProps | string]: {
    description: string;
  };
} = {
  bad_gateway_error: {
    description: "Processo interrompido. Por favor, tente novamente!",
  },
  birthdate_invalid: {
    description:
      "A data de nascimento inserida não é válida. " +
      "Por favor, verique e tente novamente.",
  },
  birthdate_minor: {
    description: "A idade mínima para cadastro no aplicativo é de 16 anos.",
  },
  document_already_exists: {
    description: "CPF já cadastrado! Por favor, faça o login",
  },
  cell_phone_number_already_exists_error: {
    description:
      "O número inserido está sendo utilizado. Por favor digite outro número.",
  },
  cpf_irregular: {
    description:
      "CPF não autorizado. " +
      "Para mais informações entre em contato com nossa central de atendimento.",
  },
  password_invalid: {
    description: "A senha deve cumprir os requisitos.",
  },
  step_divergent_error: {
    description:
      "Etapa inválida do cadastro. " +
      "Por favor, reinicie o processo de cadastro.",
  },
  system_unavailable: {
    description:
      "Não foi possível prosseguir com o cadastro. Por favor, tente novamente.",
  },
  status_invalid: {
    description:
      "Não foi possível prosseguir com o cadastro. " +
      "Por favor, tente novamente mais tarde ou entre em contato com a nossa " +
      "central de atendimento.",
  },
  invalid_token_error: {
    description:
      "O código inserio está incorreto. Por favor, verifique e tente novamente.",
  },
  token_expired: {
    description:
      'O código inserido passou do tempo limite. Por favor, clique no botão de "reenviar token".',
  },
  token_successfully_resubmitted: {
    description:
      "O código foi reenviado para o seu número de celular. " +
      "Por favor, aguarde o recebimento por SMS.",
  },
  token_not_resend: {
    description:
      "Não foi possível reenviar o código para o seu número de celular. " +
      "Por favor, tente novamente dentro de alguns instantes.",
  },
  user_name_already_exists_error: {
    description:
      "O nome de usuário já está sendo utilizado. Por favor, escolha outro.",
  },
  user_name_invalid: {
    description:
      "O nome de usuário não cumpre os requisitios. Por favor, tente novamente.",
  },
  validation_error: {
    description:
      "Um ou mais campos são obrigatórios e/ou estão em um formato inválido.",
  },
};

export const handleErrorMessage = ({
  errorSuccess,
  errorCatch,
  path,
  fieldName,
  formRef,
}: {
  errorSuccess?: any;
  errorCatch?: any;
  path?: "CreateProposal" | "SendProposalStep" | "UpdateProposalStep";
  fieldName: InputTypes;
  formRef: React.RefObject<FormHandles>;
}): void => {
  if (errorSuccess && path) {
    const statusReason = errorSuccess?.data?.[path]?.status_reason;
    const message =
      errorMessages?.[statusReason]?.description ||
      errorMessages?.system_unavailable?.description;

    formRef.current?.setErrors(
      reduceFormErrors(formRef, {
        [fieldName]: message,
      })
    );
  }

  if (errorCatch) {
    const statusReason =
      errorCatch?.graphQLErrors?.[0]?.extensions?.response?.body?.code;
    const message =
      errorMessages?.[statusReason]?.description ||
      errorMessages?.system_unavailable?.description;

    formRef.current?.setErrors(
      reduceFormErrors(formRef, {
        [fieldName]: message,
      })
    );
  }
};
